import React, { Component } from "react";
import { connect } from "react-redux";
import GridGallery from "react-grid-gallery";
import * as userActions from "../../_actions/userActions";
import * as appActions from "../../_actions/appActions";
import getGalleryImages from "../../_selectors/userSelectors/getGalleryImages";
import { map, slice, filter } from "lodash";
import Dropzone from "react-dropzone";
import Button from "../UI/Button";
import GalleryActions from "./GalleryActions";
import { confirmAlert } from "react-confirm-alert";
import { updateObject } from "../../_utils";
const overlayStyle = {
  position: "absolute",
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  padding: "2.5em 0",
  background: "rgba(0,0,0,0.5)",
  textAlign: "center",
  color: "#fff"
};
const captionStyle = {
  backgroundColor: "rgba(0, 0, 0, 0.8)",
  maxHeight: "240px",
  overflow: "hidden",
  position: "absolute",
  bottom: "0",
  width: "100%",
  color: "white",
  padding: "2px",
  fontSize: "90%",
  textAlign: "center",
  minHeight: "30px",
  lineHeight: "30px"
};
class Gallery extends Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.images.length !== prevState.galleryImages.length) {
      return { galleryImages: nextProps.images };
    } else {
      return null;
    }
  }
  state = { dropzoneActive: false, galleryImages: [] };
  componentDidMount() {
    const { updateHeader, updateBreadcrumb, getImages } = this.props;
    updateHeader({
      title: "Gallery",
      description: "Drag and drop to add new images"
    });
    updateBreadcrumb([
      { label: "Home", link: "/" },
      { label: "Gallery", link: "/gallery" }
    ]);
    this.unsubscribe = getImages();
  }
  componentWillUnmount() {
    this.unsubscribe();
  }
  onDragEnter = () => {
    this.setState({ dropzoneActive: true });
  };
  onDragLeave = () => {
    this.setState({ dropzoneActive: false });
  };
  onDrop = images => {
    const { toast, upload } = this.props;
    this.setState({ dropzoneActive: false }, () => {
      toast({ type: "info", message: "Uploading Images" });
      upload({ images });
    });
  };
  onSelectImage = (index, image) => {
    const { galleryImages } = this.state;
    let images = slice(galleryImages);
    let img = images[index];
    if (img.hasOwnProperty("isSelected")) img.isSelected = !img.isSelected;
    else img.isSelected = true;

    this.setState({
      images: images
    });
  };
  deSelectAllImages = () => {
    const { galleryImages } = this.state;
    let images = slice(galleryImages);
    let updatedImages = map(images, image => {
      return updateObject(image, { isSelected: false });
    });
    this.setState({
      galleryImages: updatedImages
    });
  };

  getSelectedImagesCount = () => {
    const { galleryImages } = this.state;
    const count = filter(galleryImages, image => {
      return image.isSelected === true;
    });
    return count.length;
  };
  getSelectedImages = () => {
    const { galleryImages } = this.state;
    const images = filter(galleryImages, image => {
      return image.isSelected === true;
    });
    return images;
  };
  openFileUpload = () => {
    this.dropzoneRef.open();
  };
  updateProfilePicture = () => {
    const { changeProfilePicture, toast } = this.props;
    const onSuccess = () => {
      toast({ type: "info", message: "Profile picture updated." });
      this.deSelectAllImages();
    };
    const onError = err => {
      toast({ type: "error", message: err });
    };
    const image = this.getSelectedImages();
    changeProfilePicture({ url: image[0].thumbnail, onSuccess, onError });
  };
  deleteImages = () => {
    const { deleteImages, toast } = this.props;
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="custom-ui">
            <h1>Are you sure?</h1>
            <p>Deleting Images cannot be undone</p>
            <button onClick={onClose}>No</button>
            <button
              onClick={() => {
                const onSuccess = () => {
                  toast({ type: "info", message: "Selected Images Deleted." });
                  this.deSelectAllImages();
                };
                const onError = err => {
                  toast({ type: "error", message: err });
                };
                deleteImages({
                  images: this.getSelectedImages(),
                  onSuccess,
                  onError
                });
                onClose();
              }}
            >
              Yes, Remove!
            </button>
          </div>
        );
      }
    });
  };
  render() {
    const { dropzoneActive, galleryImages } = this.state;

    return (
      <div className="wrapper">
        <div className="row row-wider">
          <div className="col-sm-12">
            <Dropzone
              disableClick
              style={{ position: "relative" }}
              accept="image/jpeg, image/png"
              onDrop={this.onDrop}
              onDragEnter={this.onDragEnter}
              onDragLeave={this.onDragLeave}
              ref={node => {
                this.dropzoneRef = node;
              }}
            >
              {dropzoneActive && <div style={overlayStyle}>Drop files...</div>}
              <div className="row" style={{ marginBottom: "1em" }}>
                <GalleryActions
                  selected={this.getSelectedImagesCount()}
                  onUpload={this.openFileUpload}
                  makeProfile={this.updateProfilePicture}
                  onDelete={this.deleteImages}
                />
              </div>
              <GridGallery
                images={galleryImages}
                backdropClosesModal={true}
                onSelectImage={this.onSelectImage}
              />
            </Dropzone>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  images: getGalleryImages(state)
});

const mapDispatchToProps = dispatch => ({
  getImages: () => dispatch(userActions.getGalleryImages()),
  toast: payload => dispatch(appActions.showToast(payload)),
  upload: payload => dispatch(userActions.uploadGalleryImages(payload)),
  changeProfilePicture: payload =>
    dispatch(userActions.updateProfilePicture(payload)),
  deleteImages: payload => dispatch(userActions.deleteGalleryImages(payload))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Gallery);



// WEBPACK FOOTER //
// ./src/_components/Gallery/index.js